import React, { useEffect, useState, useRef } from "react";
import "../../../Static/priceinfo.css";
import ReactToPrint from "react-to-print";
import Barcode from "react-barcode";
import axios from "axios";
import "./barcodePrint.css";
import { useParams } from "react-router-dom";
import { Button } from "@mui/material";

const baseUrl = process.env.REACT_APP_BASE_URL;

const MatInwardBarcode = () => {
  const componentRef = useRef(); // ✅ SINGLE ref for ALL barcodes
  const { inwardNo, inwardType } = useParams();
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!inwardNo || !inwardType) return;

    axios
      .get(baseUrl, {
        params: {
          apicall: "getMaterialInwardView",
          inwardNo,
          inwardType,
        },
      })
      .then((res) => {
        setData(Array.isArray(res.data.data) ? res.data.data : []);
      })
      .catch(() => setData([]));
  }, [inwardNo, inwardType]);
  const currentDate = new Date().toLocaleDateString();

  return (
    <>
      <div style={{ padding: "30px" }}></div>

      {/* PRINT BUTTON */}
      <div className="no-print" style={{ margin: "2% 5%" }}>
        <ReactToPrint
          trigger={() => (
            <Button variant="contained" color="primary">
              Print
            </Button>
          )}
          content={() => componentRef.current}
        />
      </div>

      {/* PRINTABLE CONTENT */}
      <div ref={componentRef}>
        {data.map((row, index) => (
          <div className="barcode" key={index}>
            {/* Firm */}
            <h2 className="firm">{row.firmNm}</h2>

            {/* Inward Info */}
            <div className="row">
              <span>Inward No: {inwardNo}</span>
              <span>Date: {currentDate}</span>
            </div>

            {/* <div className="row">
              <span>Date: {currentDate}</span>
            </div> */}

            {/* Material */}
            <h6 className="cloth">{row.materialNm}</h6>

            <div className="row">
              <span>Size: {row.size}</span>
              <span>M.Type: {row.mtype}</span>
            </div>
            <div className="row">
              <span>M. Qty: {row.mqty}</span>
              <span>P.Type: {row.ptype}</span>
            </div>

            <div className="row">
              <span>Per Pkt Qty: {row.perpktqty}</span>
              <span>Qty: {row.inwpqty}</span>
            </div>

            {/* BARCODE */}
            <Barcode
              value={String(row.barcode)}
              format="CODE128"
              height={40}
              width={1.2}
              displayValue
            />

            {
              row.mtype === "Pcs" ?
                <div className="row big">
                  <span>Total Qty:</span>
                  <span>{row.totqty}</span>
                </div> :
                <>
                  <div className="row big">
                    <span>Total Mtr:</span>
                    <span>{row.totmtr}</span>
                  </div>

                  <div className="row">
                    <span>Total Inch:</span>
                    <span>{row.totinch}</span>
                  </div>
                </>
            }




            <div className="row">
              <span>Location:</span>
              <span>{row.locNm}</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default MatInwardBarcode;
